import 'state/color/events/initialize'

export class Color {
  constructor(color = {}) {
    Object.assign(this, color, {
      nameEncoded: encodeURI(`${color.name}`)
    })

    Color.by.id[this.id] = this
  }
}

Color.by = {
  attribute: {
    aliases: {},
    colors: {},
    productIDs: {}
  },
  alias: {},
  id: {}
}


Color.display = {
  by: {
    color: !!MK.page.renderByColor,
    id: !!MK.page.renderByColor,
    sku: !!MK.page.renderByColor,
  }
}

console.log('Color.display', Color.display)